export default __webpack_public_path__ + "static/media/noAvailableCourses.af489f9c.png";